import { css } from "@emotion/css";
import { theme } from "@repo-sapiens/theme";

export const SettingStyle = css`
  width: 100%;
  max-width: 688px;
  margin: auto;
`;
export const SettingMenuHeaderStyle = css`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  margin-bottom: 30px;
  width: 100%;
`;
export const SettingMenuHeader2Style = css`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  margin-bottom: 30px;
  width: 100%;
  position: relative;
`;
export const SettingBackStyle = css`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  cursor: pointer;
  margin-right: 16px;
  position: absolute;
  left: 0;
`;
export const SettingHeaderTitle = css`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  width: 80%;
`;
export const SettingMenuStyle = css`
  width: 100%;
  max-width: 788px;
  padding: 24px 30px;
  margin: auto;
  border-radius: 32px;
  border: 1px solid ${theme.colors.border.primary};
  background: ${theme.colors.background.secondary};
  backdrop-filter: blur(1.5px);
  margin-top: 32px;
  @media (max-width: 765px) {
    padding: 24px 4px;
    margin-top: 90px;
  }
`;
export const SettingMenuItemStyle = css`
  padding: 8px 0;
  display: inline-flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  cursor: pointer;
`;

export const SettingSectionContainerStyle = css`
  width: 100%;
`;
export const SettingSectionStyle = css`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
  margin-bottom: 24px;
  width: 100%;
`;
export const SettingLeftStyle = css`
  display: flex;
  flex-direction: row;
  align-items: center;
  width: 70%;
`;
export const SettingIconStyle = {
  width: "18px",
  height: "18px",
  marginRight: "8px",
};
export const SettingCaretIconStyle = {
  width: "24px",
  height: "24px",
};
